import { Notification } from '.';
import { Trailer } from '../trailers/Trailer';

export const TrailerUpdatedNotification: Notification<Trailer> = {
    message: 'TrailerUpdated'
};
